export const projectTypeLowerCase = project => project.projectType.toLowerCase();